'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function t(r,n){if(r===void 0)return !1;if(r===n)return !0;if(!("__proto__"in r))return !1;let e=r.__proto__;for(;e!=null;){if(e===n||e.name===n.name)return !0;e=e.__proto__;}return !1}

exports.a = t;
